<script src="./Toolbar.js"></script>
<template src="./Toolbar.pug"></template>
<style src="./Toolbar.scss"></style>